// Which escrow service fee formula an Itinerary record is priced with. An absent value is MARKUP.
export const ESCROW_FEE_MODEL = {
  MARKUP: 'markup',
  GROSS_UP: 'gross_up',
};
